module.exports = __webpack_public_path__ + "static/media/eyeLookDownRight.b4b00b05.obj";